import { VariaveisAmbiente } from 'config';
import { ApiListSomatorioModel } from 'model/api/gestao/api-list-somatorio-model/api-list-model';
import { ComissaoModel } from 'model/api/gestao/comissao/comissao-model';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';

export function useGetComissao() {
    const { invocarApi, ...outrasPropriedades } = useApiBase<ApiListSomatorioModel<ComissaoModel>>();

    const getComissao = useCallback(
        async (page: number, queryBusca: string) => {
            let queryPage = "";
            if (page) {
                queryPage = "page=" + page.toString();
            }
            const queryFinal = `${queryPage?.length > 0 || queryBusca?.length > 0 ? "?" : ""
                }${queryPage}${queryPage.length > 0 ? "&" : ""}${queryBusca}`;

            return invocarApi({
                url: `${VariaveisAmbiente.apiVersion}/comissao${queryFinal}`,
                method: 'GET',
                enviarTokenUsuario: true
            })
        }
        , [invocarApi]
    );
    return {
        ...outrasPropriedades,
        getComissao,
    };
}
